import { render, staticRenderFns } from "./InvendoIdea.vue?vue&type=template&id=f6f7f620&"
import script from "./InvendoIdea.vue?vue&type=script&lang=js&"
export * from "./InvendoIdea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports